// extracted by mini-css-extract-plugin
module.exports = {"container":"CockpitApiStatus_container__2XnyC colors_errorColor__1bbFC"};